module.exports = __webpack_public_path__ + "img/fig16.fcd24ec5.jpg";